export default "__VITE_ASSET__DTReDuwt__"